module.exports = __webpack_public_path__ + "img/bdd1b7f.jpg";